import { z } from 'zod';

const literalBoolean = z.union([z.literal('true'), z.literal('false')]).default('false');

export const processEnvSchema = z.object({
    API_BASE_URL: z.url().endsWith('/'),
    API_REALTIME_BASE_URL: z.url().endsWith('/'),
    APP_VERSION: z.string().default('dev'),
    ENABLE_DATA_DOG: literalBoolean,
    LAUNCH_DARKLY_BASE_URL: z.url(),
    LAUNCH_DARKLY_EVENTS_URL: z.url(),
    MUI_X_LICENSE_KEY: z.string().optional(),
    REFETCH_ONFOCUS: literalBoolean,
    TINY_MCE_LICENSE_KEY: z.string().length(48).optional(),
});

export const appEnvironmentSchema = processEnvSchema.transform((env) => ({
    apiBaseUrl: env.API_BASE_URL,
    apiRealtimeBaseUrl: env.API_REALTIME_BASE_URL,
    appVersion: env.APP_VERSION,
    enableDataDog: env.ENABLE_DATA_DOG === 'true',
    launchDarklyBaseUrl: env.LAUNCH_DARKLY_BASE_URL,
    launchDarklyEventsUrl: env.LAUNCH_DARKLY_EVENTS_URL,
    muiXLicenseKey: env.MUI_X_LICENSE_KEY,
    refetchOnFocus: env.REFETCH_ONFOCUS === 'true',
    tinyMceLicenseKey: env.TINY_MCE_LICENSE_KEY,
}));

export type AppEnvironment = z.infer<typeof appEnvironmentSchema>;
